import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas, parseNumberWithCommas } from '../../../../../helpers';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderInput from '../../../../../common/components/render-input';

export const formName = Routes.STEPTWO;

const loanAmountMin = 1000;
const loanAmountMax = 1000000;

const validate = values => v(values, {
    loanAmount: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        },
        numericality: {
            greaterThanOrEqualTo: loanAmountMin,
            notGreaterThanOrEqualTo: `must be greater than or equal to $${numberWithCommas(loanAmountMin)}`,
            lessThanOrEqualTo: loanAmountMax,
            notLessThanOrEqualTo: `must be less than or equal to $${numberWithCommas(loanAmountMax)}`
        }
    }
});

class StepTwoForm extends Component {
    render() {
        return (
            <form className={styles.form}>
                <Field
                    type='text'
                    name='loanAmount'
                    label='Loan Amount'
                    prefix='$'
                    format={numberWithCommas}
                    parse={parseNumberWithCommas}
                    component={RenderInput}
                />
            </form>
        );
    }
}

StepTwoForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: {
        loanAmount: 500000
    },
    redirectPath: `/loan${Routes.STEPTHREE}`
})(StepTwoForm);

export default withRouter(StepTwoForm);
